import { useEffect } from 'react';
import { FlexContainer, Text, Spinner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import AccountNotify from '../AccountNotify';
import AccountDelete from '../AccountDelete';
import TermsAndConditions from '../TermsAndConditions';
import { useFetchGetNotificationPreference } from '../../hooks';
import { AccountPrivacyProps } from './types';

const Privacy = ({ setSubContent, setScreen }: AccountPrivacyProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const { data, isLoading } = useFetchGetNotificationPreference();

  useEffect(() => {
    setSubContent(true);
  }, []);

  if (isLoading) {
    return (
      <FlexContainer justify="center" align="center">
        <Spinner size="M" justify="center" align="center" />
      </FlexContainer>
    );
  }
  return (
    <>
      <Text type="fds_heading_bold_H4" color="dark" mb="fds_size_56">
        {t('Privacy.title')}
      </Text>
      <AccountNotify data={data} />
      <AccountDelete setScreen={setScreen} setSubContent={setSubContent} />
      <FlexContainer justify="center" mt="fds_size_96" align="center">
        <TermsAndConditions />
      </FlexContainer>
    </>
  );
};

export default Privacy;
